import { WithChakra } from 'src/contexts/Chakra';
import { PageLayout } from 'src/components/PageLayout';
import FooterSuporte from 'src/components/FooterSuporte';

const WithTheme = BaseComponent => {
  const WrappedComponent = props => (
    <WithChakra>
      <PageLayout>
        <BaseComponent {...props} />
        <FooterSuporte />
      </PageLayout>
    </WithChakra>
  );

  return WrappedComponent;
};

export default WithTheme;
